import { MessageCircle } from "lucide-react";
import { formatPhoneNumberIntl } from "react-phone-number-input";

/**
 * Affiche un numéro de téléphone cliquable qui ouvre directement WhatsApp.
 * - phone : numéro (E.164 de préférence, ex "+2250140456948")
 * - fallback : ce qu'on affiche si le numéro est vide (def "—")
 * - showIcon : affiche l'icône WhatsApp (def true)
 */
export default function WhatsAppLink({ phone, fallback = "—", showIcon = true, className = "" }) {
  if (!phone) return <span className="text-slate-400">{fallback}</span>;
  const digits = String(phone).replace(/[^0-9]/g, "");
  if (!digits) return <span>{phone}</span>;
  let display = phone;
  try {
    display = formatPhoneNumberIntl(phone.startsWith("+") ? phone : `+${digits}`) || phone;
  } catch {
    display = phone;
  }
  return (
    <a
      href={`https://wa.me/${digits}`}
      target="_blank"
      rel="noreferrer noopener"
      data-testid="whatsapp-link"
      title="Ouvrir la conversation WhatsApp"
      className={`inline-flex items-center gap-1 font-semibold text-emerald-600 transition-colors hover:text-emerald-700 hover:underline ${className}`}
    >
      {showIcon && <MessageCircle className="h-3.5 w-3.5 shrink-0" />}
      {display || phone}
    </a>
  );
}
